<template>
  <div v-if="isShow" class="oap-register-now-popup">
    <div class="oap-register-now-popup-wrapper"></div>

    <div class="pop-up-content">
      <div class="pop-up-close-btn">
        <button aria-label="register-now-popup-close-btn" @click="onClickCloseBtn">
          <img alt="close-btn-icon" src="/frontend/static/images/close-register-now-popup.svg" />
        </button>
      </div>

      <div class="pop-up-logo">
        <picture>
          <source media="(min-width:650px)" :srcset="popupLogoDesktopSrc" />
          <source media="(min-width:300px)" :srcset="popupLogoMobileSrc" />
          <img :src="popupLogoDesktopSrc" alt="register-now-popup-logo" />
        </picture>
      </div>

      <div class="line-separator" />

      <div class="pop-up-description">
        <p>{{ popupDescription }}</p>
      </div>

      <div class="pop-up-register-button">
        <a :href="popupRegisterUrl">{{ popupRegisterBtnLabel }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OapRegisterNowPopup',
  props: {
    popupLogoDesktopSrc: { default: '/frontend/static/images/logo_white_x1.5.png', type: String },
    popupLogoMobileSrc: { default: '/frontend/static/images/logo_white_x1.png', type: String },
    popupDescription: { default: '', type: String },
    popupRegisterBtnLabel: { default: 'Register Now', type: String },
    popupRegisterUrl: { default: '', type: String },
  },
  data() {
    return {
      isShow: false,
    };
  },
  mounted() {
    const getRegisterNowShowStatus = localStorage.getItem('register-now-popup-status');

    if (!getRegisterNowShowStatus) {
      this.isShow = true;
      document.querySelector('body').classList.add('noScroll');
      localStorage.setItem('register-now-popup-status', 'true');
    }
  },
  methods: {
    onClickCloseBtn() {
      this.isShow = false;
      document.querySelector('body').classList.remove('noScroll');
    },
  },
};
</script>
